class CreateBatchAccountingSessionsReq {
  constructor() {
    this.PatientId = null;
    this.Sessions = [];
    this.AccountingEntryId = null;
  }
}
export default CreateBatchAccountingSessionsReq;